import { Component, Fragment } from 'react'
import { ResourceType } from '@ds-frontend/resource'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'

import HeaderQuote from '../widgets/HeaderQuote'
import QuoteListView from './QuoteListView'
import { Loading } from 'common/widgets'
import classNames from './styles.module.scss'


const propTypes = {
  uuid: PropTypes.string.isRequired,
  quoteList: ResourceType.isRequired,
  withoutHeader: PropTypes.bool,
}

const defaultProps = {
  withoutHeader: false,
}

export default class QuoteListContainer extends Component {
  render() {
    const quote = get(this.props.quoteList, 'data', {})
    return (
      <Fragment>
        {!this.props.withoutHeader && (
          <HeaderQuote uuid={this.props.uuid} />
        )}
        <Loading isLoading={isEmpty(quote)} className={classNames.loading}>
          <QuoteListView quote={quote} uuid={this.props.uuid} />
        </Loading>
      </Fragment>
    )
  }
}

QuoteListContainer.propTypes = propTypes
QuoteListContainer.defaultProps = defaultProps
